// extracted by mini-css-extract-plugin
module.exports = {"page_location":"styles_page_location__16JB0","region":"styles_region__kI6Q_"};